import React from "react";
import {
  Dialog,
  Box,
  IconButton,
  Button,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import CloseRounded from "@mui/icons-material/CloseRounded";
import SendRounded from "@mui/icons-material/SendRounded";
import { black, greyEnabled, purple, purpleLight } from "../../../theme/colors";

type Props = {
  open: boolean;
  isLoading: boolean;
  onClose: () => void;
  onConfirm: () => void;
  filledLanguages: string[];
};

export const ConfirmLanguagesDialog: React.FC<Props> = ({
  open,
  isLoading,
  onClose,
  onConfirm,
  filledLanguages,
}) => {
  return (
    <Dialog open={open} onClose={isLoading ? undefined : onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
      <Box sx={{ width: 420, maxWidth: "90vw", p: 2 }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1.5}>
          <Box display="flex" alignItems="center" gap={1.5}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 36,
                height: 36,
                borderRadius: 2,
                bgcolor: purpleLight,
                flexShrink: 0,
              }}
            >
              <SendRounded sx={{ color: purple, fontSize: 20 }} />
            </Box>
            <Typography fontWeight={700} fontSize={17} color={black}>
              Confirm Submission
            </Typography>
          </Box>
          <IconButton onClick={onClose} size="small" disabled={isLoading} sx={{ "&:hover": { bgcolor: purpleLight } }}>
            <CloseRounded fontSize="small" sx={{ color: "#5B4A5A" }} />
          </IconButton>
        </Box>

        <Typography variant="body2" color={greyEnabled}>
          Content has been filled for the following languages:
        </Typography>

        <Grid container spacing={1} mt={0.5}>
          {filledLanguages.map((lang, index) => (
            <Grid item xs={4} key={index}>
              <Typography
                variant="body2"
                fontWeight={600}
                sx={{
                  p: 1,
                  border: `1px solid ${purpleLight}`,
                  borderRadius: 2,
                  textAlign: "center",
                  bgcolor: purpleLight,
                  color: purple,
                }}
              >
                {lang}
              </Typography>
            </Grid>
          ))}
        </Grid>

        <Typography variant="body2" color={greyEnabled} mt={2}>
          Are you sure you want to proceed with submission?
        </Typography>

        <Box mt={2} display="flex" gap={1.5}>
          <Button
            fullWidth
            variant="outlined"
            disabled={isLoading}
            onClick={onClose}
            sx={{
              borderColor: purple,
              color: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: purple, bgcolor: purpleLight },
            }}
          >
            No, Add more
          </Button>
          <Button
            fullWidth
            variant="contained"
            disableElevation
            disabled={isLoading}
            onClick={onConfirm}
            sx={{
              bgcolor: purple,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { bgcolor: "#7A2074" },
            }}
          >
            {isLoading ? <CircularProgress size={18} sx={{ color: "#fff" }} /> : "Send"}
          </Button>
        </Box>
      </Box>
    </Dialog>
  );
};
